import BulkInviteContainer from './BulkInviteContainer';

export default BulkInviteContainer;
